import { defineNuxtPlugin } from '#app';
import { usePageStore } from '~dsc/stores/cms/page.js';

export default defineNuxtPlugin(nuxtApp => {
    const { $i18n: { t } } = nuxtApp;

    nuxtApp.hook('dsc:cms-page-load-request:success', body => {
        const { content = {} } = body.value;
        const {
            description,
            openGraphTitle,
            openGraphDescription,
            station,
            contentType,
        } = content;
        if (contentType === 'stationPageTemplate') {
            usePageStore().$patch({ useSiteTitle: false });
            const stationName = station?.name;
            const locality = [ station?.postcode, station?.city ].filter(Boolean).join(' ');
            const stationAddress = [ stationName, station?.street, locality ].filter(Boolean).join(', ');
            if (stationName) {
                body.value.content.title = stationName;
            }
            body.value.content.openGraphTitle = openGraphTitle ?? stationName ?? body.value.content.openGraphTitle;
            body.value.content.description = description ?? t('stationPage.metaDescription', { stationAddress });
            body.value.content.openGraphDescription = openGraphDescription ?? t('stationPage.metaDescription', { stationAddress });
        }
    });
});
